import signalrConnection from '@signalrConnection'
import store from '@/store'

export default function useYoungsSocket(storeModuleName) {
    const registerSocket = () => {
        if (signalrConnection?.state !== 'Connected') {
            console.warn('SignalR not connected, listeners will be registered when connected')
            setTimeout(() => registerSocket(), 1000)
            return
        }

        // Register listeners only if they're not already registered
        // This prevents duplicate listener registration
        if (!signalrConnection.receiveMessageRegistered) {
            signalrConnection.on('ReceiveMessage', message => {
                store.dispatch(`${storeModuleName}/addOrUpdateMessage`, message)
            })
            signalrConnection.receiveMessageRegistered = true
        }

        if (!signalrConnection.receiveYoungRegistered) {
            signalrConnection.on('ReceiveYoung', young => {
                store.dispatch(`${storeModuleName}/addOrUpdateYoung`, young)
            })
            signalrConnection.receiveYoungRegistered = true
        }

        if (!signalrConnection.deleteYoungRegistered) {
            signalrConnection.on('DeleteYoung', youngId => {
                store.dispatch(`${storeModuleName}/deleteYoung`, youngId)
            })
            signalrConnection.deleteYoungRegistered = true
        }

        if (!signalrConnection.receiveConversationStatusRegistered) {
            signalrConnection.on('ReceiveConversationStatus', takeCare => {
                store.commit(`${storeModuleName}/updateConversationStatus`, {
                    youngId: takeCare.youngId,
                    conversationStatus: takeCare.conversationStatus,
                    userId: takeCare.userId,
                })
            })
            signalrConnection.receiveConversationStatusRegistered = true
        }
    }

    const unregisterSocket = () => {
        if (!signalrConnection) {
            return
        }

        signalrConnection.off('ReceiveMessage')
        signalrConnection.off('ReceiveYoung')
        signalrConnection.off('DeleteYoung')
        signalrConnection.off('ReceiveConversationStatus')

        // Reset flags so listeners are re-registered if the component remounts
        signalrConnection.receiveMessageRegistered = false
        signalrConnection.receiveYoungRegistered = false
        signalrConnection.deleteYoungRegistered = false
        signalrConnection.receiveConversationStatusRegistered = false
    }

    return { registerSocket, unregisterSocket }
}
